import {lazy} from 'react'

const PanelRoutes = [
    // admin
    {
        path: 'admin/dashboard',
        component: lazy(() => import('@src/views/panel/admin/Dashboard')),
        auth: true
    },
    {
        path: 'admin/articles',
        component: lazy(() => import('@src/views/panel/admin/Articles')),
        auth: true
    },
    {
        path: 'admin/articles-categories',
        component: lazy(() => import('@src/views/panel/admin/ArticlesCategories')),
        auth: true
    },
    {
        path: 'admin/services-category',
        component: lazy(() => import('@src/views/panel/admin/serviceCategory')),
        auth: true
    },
    {
        path: 'admin/services',
        component: lazy(() => import('@src/views/panel/admin/ServicesPanel')),
        auth: true
    },
    {
        path: 'admin/products-categories',
        component: lazy(() => import('@src/views/panel/admin/ProductCategory')),
        auth: true
    },
    {
        path: 'admin/products',
        component: lazy(() => import('@src/views/panel/admin/ProductManagement')),
        auth: true
    },

    {
        path: 'admin/sliders',
        component: lazy(() => import('@src/views/panel/admin/manageSliders')),
        auth: true
    },
    {
        path: 'admin/Personnel',
        component: lazy(() => import('@src/views/panel/admin/Personnel')),
        auth: true
    },
    {
        path: 'admin/Activity',
        component: lazy(() => import('@src/views/panel/admin/Activity')),
        auth: true
    },
    {
        path: 'admin/faq',
        component: lazy(() => import('@src/views/panel/admin/manageFaq')),
        auth: true
    },
    {
        path: 'admin/contactus',
        component: lazy(() => import('@src/views/panel/admin/ContactusManagemet')),
        auth: true
    },
    {
        path: 'admin/gallery',
        component: lazy(() => import('@src/views/panel/admin/Gallery')),
        auth: true
    },
    {
        path: 'admin/Stories',
        component: lazy(() => import('@src/views/panel/admin/Stories')),
        auth: true
    },
    {
        path: 'admin/menu-management',
        component: lazy(() => import('../../views/panel/admin/MenuManagement/index')),
        auth: true
    },
    {
        path: 'admin/collaboration-requests',
        component: lazy(() => import('@src/views/panel/admin/CollaborationRequests')),
        auth: true
    },
 /*   {
        path: 'admin/employment-requests',
        component: lazy(() => import('@src/views/panel/admin/EmploymentRequests')),
        auth: true
    }*/
]

export default PanelRoutes
